import { data } from '../../svg/MarkNoteRead/data';
import { makeIcon } from '../makeIcon';

export const MarkNoteRead = makeIcon(data, 'mark_note_read', 'MarkNoteRead');

export default MarkNoteRead;
